import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { Direction, } from '@debbie/common/dist/interactions/index.js';
import { Badge } from '..//index.js';
import THEME from '../../theme.js';
import { PreviewWrapper } from '../PreviewWrapper.js';
const EmailPreview = (props) => {
    const email = props.interaction.details;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(PreviewWrapper, { selected: props.selected, onClick: props.onClick },
        React.createElement("h1", null,
            lang.interactionTypes.EMAIL,
            ' ',
            props.interaction.paused && (React.createElement(Badge, { theme: THEME.WARNING }, lang.cases.casePaused)),
            React.createElement("small", { style: {
                    float: 'right',
                } }, moment(props.interaction.createdAt).format(THEME.DATE_FORMAT_LONG))),
        React.createElement("p", { className: "subject" }, email.subject),
        React.createElement("p", null,
            email.body && email.body.substr(0, 64),
            email.body && email.body.length > 64 ? '...' : ''),
        React.createElement("p", { className: "address" }, props.interaction.direction === Direction.OUTGOING
            ? email.to
            : email.from)));
};
export default EmailPreview;
//# sourceMappingURL=EmailPreview.js.map